export default "__VITE_ASSET__DEz7CtR0__"